import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonComponent } from './button.component';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, ProgressSpinnerModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
